import { FaHome } from "react-icons/fa"; 
import { Link, useParams } from "react-router-dom";
import version from './../../package.json';
import AdmissionForm from "../Components/Admission/AdmissionForm";

const AdmissionBaseLayout = ({part,course,courseFullName}) => {





  return (
     <div className="admission-container">


      {/* <ul className="Admission_Form_Header">
        <li><Link to="/" style={{color:'inherit'}}>Skip to main content</Link></li>
         
      </ul> */}

      {/* <ul className="Header-section">
        <li>
          <div className="arrow-box"></div>
        </li>
        <li className="first-section">
          <img
            src="https://content.acetians.in/uploads/IMG-20250624-WA0001[1].jpg"
            className="header-img"
            alt="Uttar Pradesh Government Seal"
          />
          <div>
            <h1>राजकीय महाविद्यालय मिलक रामपुर (उ.प्र.)</h1>
            <h2>Government Degree College Milak Rampur (U.P.)</h2>
          </div>
        </li>
        <li>
          <div className="arrow-box" style={{ rotate: "180deg" }}></div>
        </li>
      </ul> */}
      <ul className="application_info">
        <li>
          <a style={{color:'inherit'}} href="/">
              <FaHome />
            </a>
        </li>
        <li>
           Application for {courseFullName}({course})-{part} 
        </li>
        <li>
            v-{version.version}
        </li>
      </ul>
      

      <div className="form-container">
          <AdmissionForm part={part} course={course}/>
      </div>
    </div>
  );
};

export default AdmissionBaseLayout;
